import { Tooltip } from '@mui/material'
import { convertFifaCodeToAlpha2, getCountryNameFromFifaCode } from '@/utils/countryCodeConverter'

import { CircleFlag } from './CircleFlag'

interface FlagWithTooltipProps {
  fifaCode: string
  height?: number
  countryName?: string
}

/**
 * CircleFlag with tooltip showing country name
 *
 * Handles conversion from FIFA country codes to alpha-2 codes for CircleFlag.
 * Shows the country name in a tooltip on hover.
 */
export const FifaCircleFlag: React.FC<FlagWithTooltipProps> = ({
  fifaCode,
  height = 20,
  countryName
}) => {
  const alpha2Code = convertFifaCodeToAlpha2(fifaCode)
  const displayCountryName = countryName || getCountryNameFromFifaCode(fifaCode)

  return (
    <Tooltip title={displayCountryName} arrow placement="top">
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        <CircleFlag countryCode={alpha2Code} height={height} />
      </span>
    </Tooltip>
  )
}
